function printArticle() {
  var articleContainer = document.querySelector('.article-container');
  if (!articleContainer) return;

  var printContent = articleContainer.innerHTML;
  var printWindow = window.open('', '', 'width=800,height=600');
  if (!printWindow) return;

  printWindow.document.write(
    '<html>' +
      '<head>' +
        '<title>Print Article</title>' +
        '<style>' +
          '* { margin: 0; padding: 0; box-sizing: border-box; }' +
          '@page { margin: 0; }' +
          'body, html { margin: 0; padding: 0; font-family: Arial, sans-serif; overflow: visible; }' +
          '.print-container { max-width: 800px; margin: auto; padding: 20px; }' +
          '.article-header { margin-bottom: 20px; }' +
          'h1 { font-size: 24px; margin-bottom: 15px; }' +
          '.author-p { margin-bottom: 10px; }' +
          'p { padding-bottom: 10px; }' +
          '.print-container img { display: block; margin: 20px auto; max-width: 80%; height: auto; }' +
          '.print-container a { color: inherit; text-decoration: none; pointer-events: none; cursor: default; }' +
          '.print-container, h1, p, .article-content * { page-break-inside: avoid !important; page-break-after: auto !important; }' +
          '.share-buttons-container, .similar-articles, .shop-the-story, .next-article-container, hr { display: none !important; }' +
        '</style>' +
      '</head>' +
      '<body>' +
        '<div class="print-container">' +
          printContent +
        '</div>' +
      '</body>' +
    '</html>'
  );

  printWindow.document.close();
  printWindow.print();
  printWindow.onafterprint = function () {
    printWindow.close();
  };
}

function shareEvent(platform, element) {
  var articleContainer = document.querySelector('.article-container');
  var title = element.getAttribute('data-title');

  if (typeof gtag === 'function') {
    gtag('event', 'share', {
      event_category: 'Social',
      event_label: platform,
      value: title,
    });
  }

  if (!articleContainer) return;

  var baseUrl = articleContainer.dataset.articleUrl || '';
  var description = articleContainer.dataset.articleExcerpt || '';
  var image = articleContainer.dataset.articleImage || '';
  var shareUrl = '';

  switch (platform) {
    case 'Facebook':
      shareUrl = 'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(baseUrl);
      break;
    case 'Twitter':
      shareUrl =
        'https://twitter.com/intent/tweet?url=' +
        encodeURIComponent(baseUrl) +
        '&text=' +
        encodeURIComponent(description);
      break;
    case 'Pinterest':
      shareUrl =
        'https://www.pinterest.com/pin/create/button/?url=' +
        encodeURIComponent(baseUrl) +
        '&media=' +
        encodeURIComponent(image) +
        '&description=' +
        encodeURIComponent(description);
      break;
    default:
      return;
  }

  if (platform === 'Facebook' || platform === 'Twitter' || platform === 'Pinterest') {
    var width = 600;
    var height = 400;
    var left = window.screenX + (window.outerWidth - width) / 2;
    var top = window.screenY + (window.outerHeight - height) / 2;

    window.open(
      shareUrl,
      '_blank',
      'width=' +
        width +
        ',height=' +
        height +
        ',top=' +
        top +
        ',left=' +
        left +
        ',resizable=yes,scrollbars=yes,status=yes'
    );
  }
}
